import React, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Details } from "./Details";
import { Prices } from "./Prices";
import { Comments } from "./Comments";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export const TabsComp = ({ data, comments }) => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className='serviceItemTabs  SuitableCars vendorPage '>
      <Box sx={{ width: "100%", direction: "rtl" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='basic tabs example'>
            <Tab label='جزییات' {...a11yProps(0)} />
            <Tab label='قیمت ها' {...a11yProps(1)} />
            <Tab label='نظرات' {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Details data={data} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Prices data={data} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Comments comments={comments} />
        </TabPanel>
      </Box>
    </div>
  );
};
